import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit } from "@angular/core";
import { Adb2cService } from "@app/blocks/adb2c/services/adb2c/adb2c.service";
import { RepairsDashboard } from "@app/interfaces/repairs-dashboard";
import { RepairDashboardService } from "@app/repairs/services/repair-dashboard.service";
import { SpinnerComponent } from "@app/shared/components/spinner/spinner.component";
import moment from "moment";
import { Subject, Subscription } from "rxjs";
import { RepairSummaryComponent } from "../repair-summary/repair-summary.component";
@Component({
   selector: "app-repair-dashboard",
   imports: [CommonModule, RepairSummaryComponent, SpinnerComponent],
   templateUrl: "./repair-dashboard.component.html",
   styleUrl: "./repair-dashboard.component.scss",
})
export class RepairDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
   @Input() pageHeading: string = "";
   @Input() errorText: string = "";
   @Input() roleNuvu: string = "";
   @Input() rolePrs: string = "";
   @Input() repairBookingAvailable: string = "true";
   private destroy$ = new Subject<void>();
   private userSubscription?: Subscription;

   loading: boolean = true;
   error: boolean = false;
   config = {
      filterFromDate: moment().subtract(12, "weeks"),
      filterToDate: moment(),
   };

   repairsData: RepairsDashboard = {
      appointmentsFound: true,
      futureAppointments: [],
      previousAppointments: [],
      repair: null,
      repairStage: "",
   };

   constructor(
      private repairDashBoardService: RepairDashboardService,
      private el: ElementRef,
      private adb2cService: Adb2cService
   ) {}
   ngOnInit() {
      const cpt = this.el.nativeElement;
      this.pageHeading = cpt.getAttribute("pageHeading");
      this.errorText = cpt.getAttribute("errorText");
      this.roleNuvu = cpt.getAttribute("roleNuvu");
      this.rolePrs = cpt.getAttribute("rolePrs");
      this.repairBookingAvailable = cpt.getAttribute("repairBookingAvailable") ?? "true";
   }

   ngAfterViewInit() {
      this.adb2cService.getUser();

      this.userSubscription = this.adb2cService.activeUser.asObservable().subscribe((user) => {
         if (user !== null && user.sub && user["tenancy_reference"]) {
            console.log("Fetching repair dashboard for user: ", user.sub);
            this.repairDashBoardService
               .getRepairDashboard(
                  user.sub,
                  user["tenancy_reference"]!,
                  this.config.filterFromDate.format("YYYY[%2F]MM[%2F]DD"),
                  this.config.filterToDate.format("YYYY[%2F]MM[%2F]DD")
               )
               .subscribe({
                  next: (response) => {
                     this.repairsData = response;
                     console.log("Repairs Data", this.repairsData);
                     this.loading = false;
                  },
                  error: (error) => {
                     console.error(error);
                  },
               });
         }
      });
   }

   ordinalDate(date: any) {
      return moment(date).format("Do");
   }

   ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();

      this.userSubscription?.unsubscribe();
   }
}
